import type { ReactNode } from 'react';
import './chat-ui.css';

type ChatComposerShellProps = {
  children: ReactNode;
  trailing?: ReactNode;
  leading?: ReactNode;
  toolbar?: ReactNode;
  disabled?: boolean;
  className?: string;
};

function ChatComposerShell({
  children,
  trailing,
  leading,
  toolbar,
  disabled = false,
  className = '',
}: ChatComposerShellProps) {
  return (
    <div
      className={`chat-composer-shell relative flex flex-col w-full rounded-full border border-[#E4E4E7] bg-white transition-[border-color,outline-color] ${
        disabled ? 'opacity-50 cursor-not-allowed' : ''
      } ${className}`}
    >
      {toolbar ? (
        <div className="chat-composer-toolbar flex flex-wrap items-center gap-1.5 w-full px-3 pt-2 pb-1 border-b border-zinc-100">
          {toolbar}
        </div>
      ) : null}
      <div className="flex items-center w-full pl-2 pr-2 py-1.5 gap-1">
        {leading ? <div className="flex flex-shrink-0 items-center">{leading}</div> : null}
        <div className="flex-1 min-w-0 flex items-center">{children}</div>
        {trailing ? <div className="flex flex-shrink-0 items-center gap-1">{trailing}</div> : null}
      </div>
    </div>
  );
}

ChatComposerShell.defaultProps = {
  trailing: undefined,
  leading: undefined,
  toolbar: undefined,
  disabled: false,
  className: '',
};

export default ChatComposerShell;
